import React from 'react';
import {
    StyledDialogIcon,
    StyledDescription,
    StyledDialogContainer, StyledTitle
} from './styles';
import Button from "../button";

const Dialog = ({
                    icon,
                    title,
                    description,
                    isLoading,
                    primaryButtonText,
                    onPrimaryButtonClicked,
                    isSecondaryButton,
                    secondaryButtonText,
                    onSecondaryButtonClicked
                }) => {
    return (
        <StyledDialogContainer>
            <StyledDialogIcon src={icon}/>
            <StyledTitle>{title}</StyledTitle>
            {description && <StyledDescription>{description}</StyledDescription>}
            <Button type='filled' width="100%" onClick={onPrimaryButtonClicked}>
                {isLoading ? '...' : primaryButtonText}
            </Button>
            {isSecondaryButton && onSecondaryButtonClicked ?
                <Button type='outline' width="100%"
                        onClick={onSecondaryButtonClicked}>{secondaryButtonText}</Button> : null}
        </StyledDialogContainer>
    );
};
export default Dialog;
